import { makeHead } from '@/root/components/shared/DayPicker/CustomWeekBar'

export const Head = makeHead(
  'border-neutral-normal-lighter text-primary-base translate-y-2 border-b text-lg',
)
